/* eslint-disable */
// import { validation } from './commonValidation';

const removeUsr = () => {
  const removeForm = document.querySelector('.js-remove-account');
  const removeBtn = document.querySelector('.js-remove-button');
  const removeBtnCompany = document.querySelector('.js-remove-button-company');

  const removeCompanyAjax = e => {
    e.preventDefault();
    e.target.classList.add('is-loading');
    const ajax_url = document.querySelector('meta[name="adjx"]').content;
    const company = removeForm.dataset.company;
    let ajaxData = {
      action: 'ks_remove_company',
      company: company,
    };

    let ajaxParameters = Object.entries(ajaxData)
      .map(e => e.join('='))
      .join('&');

    let request = new XMLHttpRequest();
    request.open('POST', ajax_url, true);

    request.setRequestHeader(
      'Content-Type',
      'application/x-www-form-urlencoded;',
    );

    request.onload = function() {
      if (this.status >= 200 && this.status < 400) {
        let cards = document.querySelectorAll('.c-card');
        cards.forEach(element => {
          element.classList.add('u-hidden');
        });
        document.querySelector('.js-pass-success').classList.remove('u-hidden');
      }
    };

    request.onerror = function() {};

    request.send(ajaxParameters);
  };
  const removeUsrAjax = e => {
    e.preventDefault();
    const ajax_url = document.querySelector('meta[name="adjx"]').content;
    let ajaxData = {
      action: 'ks_remove_user',
    };

    let ajaxParameters = Object.entries(ajaxData)
      .map(e => e.join('='))
      .join('&');

    let request = new XMLHttpRequest();
    request.open('POST', ajax_url, true);

    request.setRequestHeader(
      'Content-Type',
      'application/x-www-form-urlencoded;',
    );

    request.onload = function() {
      if (this.status >= 200 && this.status < 400) {
        let cards = document.querySelectorAll('.c-card');
        cards.forEach(element => {
          element.classList.add('u-hidden');
        });
        document.querySelector('.js-pass-success').classList.remove('u-hidden');
      }
    };

    request.onerror = function() {};

    request.send(ajaxParameters);
  };

  const counter = () => {
    let counterInterval = setInterval(() => {
      let currentNumberPlace = document.querySelector('.js-counter');
      let currentNumber = parseInt(
        document.querySelector('.js-counter').innerHTML.substring(1, 2),
        10,
      );
      if (currentNumber > 0) {
        currentNumberPlace.innerHTML = `(${currentNumber - 1})`;
      } else {
        if (removeBtn) {
          removeBtn.classList.remove('c-button--disabled');
          removeBtn.classList.remove('c-button--disabled-colored');
          removeBtn.classList.remove('c-button--tertiary');
          removeBtn.classList.add('c-button--error');
          removeBtn.classList.add('c-button--alternetive');
        }
        if (removeBtnCompany) {
          removeBtnCompany.classList.remove('c-button--disabled');
          removeBtnCompany.classList.remove('c-button--disabled-colored');
          removeBtnCompany.classList.remove('c-button--tertiary');
          removeBtnCompany.classList.add('c-button--error');
          removeBtnCompany.classList.add('c-button--alternetive');
        }
        currentNumberPlace.innerHTML = '';
        clearInterval(counterInterval);
      }
    }, 1000);
  };

  if (removeForm) {
    counter();
    if (removeBtn) {
      removeBtn.addEventListener('click', removeUsrAjax);
    }
    if (removeBtnCompany) {
      removeBtnCompany.addEventListener('click', removeCompanyAjax);
    }
  }
};

export default removeUsr;



// WEBPACK FOOTER //
// ./wp/wp-content/themes/trade-gov-chisel/src/scripts/modules/removeUsr.js